import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode;
}

export default function AddControl({ className, label, ...props }: Props) {
  return (
    <div className={classNames('text-primary clickable', className)} {...props}>
      <FontAwesomeIcon className="me-1" icon={faCirclePlus} />
      {label}
    </div>
  );
}
